import { CreditScore } from '@mui/icons-material';
import { Alert, AlertTitle, Button, FormControl, FormControlLabel, Radio, RadioGroup, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';

type MemberFamilyCreateModeSelectorProps = {
  payingMember: boolean | undefined;
  payingMemberCallback: (val: boolean | undefined) => void;
};

export const MemberFamilyCreateModeSelector = (props: MemberFamilyCreateModeSelectorProps) => {
  const { payingMember, payingMemberCallback } = props;
  const { t } = useTranslation(['member']);

  return (
    <>
      <Alert color='info' sx={{ minHeight: '10rem' }} icon={<CreditScore />}>
        <AlertTitle sx={{ mb: 1 }}>{t('member:createMember.hasPaymentQuestion')}</AlertTitle>
        <FormControl>
          <RadioGroup>
            <Stack spacing={1} direction='row'>
              <Button onClick={() => payingMemberCallback(true)} variant='contained' color='primary' disableElevation>
                <FormControlLabel
                  control={
                    <Radio
                      checked={payingMember !== undefined && payingMember}
                      sx={{
                        color: (thm) => thm.palette.primary.contrastText,
                        '&.Mui-checked': {
                          color: (thm) => thm.palette.primary.contrastText,
                        },
                      }}
                    />
                  }
                  label={t('member:createMember.payment.yes')}
                />
              </Button>
              <Button onClick={() => payingMemberCallback(false)} variant='outlined' color='primary' disableElevation>
                <FormControlLabel
                  control={<Radio checked={payingMember !== undefined && !payingMember} />}
                  label={t('member:createMember.payment.no')}
                />
              </Button>
            </Stack>
          </RadioGroup>
        </FormControl>
      </Alert>
    </>
  );
};
